import { useTheme } from "@mui/material/styles";

const LiveViewIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3332 7.44281C18.3332 6.93797 18.3332 6.68554 18.2333 6.56866C18.1467 6.46724 18.0168 6.41341 17.8838 6.42388C17.7306 6.43594 17.5521 6.61443 17.1951 6.97141L14.1665 10L17.1951 13.0286C17.5521 13.3856 17.7306 13.5641 17.8838 13.5761C18.0168 13.5866 18.1467 13.5328 18.2333 13.4314C18.3332 13.3145 18.3332 13.062 18.3332 12.5572V7.44281Z"
        stroke={theme.palette.primary.contrastText}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.6665 8.16667C1.6665 6.76654 1.6665 6.06647 1.93899 5.5317C2.17867 5.06129 2.56112 4.67884 3.03153 4.43916C3.56631 4.16667 4.26637 4.16667 5.6665 4.16667H10.1665C11.5666 4.16667 12.2667 4.16667 12.8015 4.43916C13.2719 4.67884 13.6543 5.06129 13.894 5.5317C14.1665 6.06647 14.1665 6.76654 14.1665 8.16667V11.8333C14.1665 13.2335 14.1665 13.9335 13.894 14.4683C13.6543 14.9387 13.2719 15.3212 12.8015 15.5609C12.2667 15.8333 11.5666 15.8333 10.1665 15.8333H5.6665C4.26637 15.8333 3.56631 15.8333 3.03153 15.5609C2.56112 15.3212 2.17867 14.9387 1.93899 14.4683C1.6665 13.9335 1.6665 13.2335 1.6665 11.8333V8.16667Z"
        stroke={theme.palette.primary.contrastText}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LiveViewIcon;
